<template>
  <div class="menuData_warp">
    <el-menu
      @select="handleSelect"
      collapse-transition
      @open="handleOpen"
      :default-active="activeMenu"
      background-color="rgb(27, 61, 109)"
      text-color="#fff"
      active-text-color="#ffffff">
      <!-- 引入组件 -->
      <menu-tree :menuData="menuList"></menu-tree>
    </el-menu>
  </div>
</template>

<script>
import MenuTree from '../components/MentTree.vue'
import { mapState } from 'vuex';
export default {
  name: 'menuData',
  props: ['menuTree'],
  components: {
    MenuTree
  },
  data () {
    return {
      activeMenu:this.$store.state.activeMenu,
      statusData: {},
      menuList: [
        {
          index: '/Home',
          name: '首页',
          isShow: 1,
          allowViewing: 1

        },
        {
          index: '1',
          name: '待办清单',
          isShow: 1,
          allowViewing: 1,
          children: [
            {
              index: '/trialBZ',
              name: '初审材料补正',
              isShow: 1,
              allowViewing: 1

            },
            {
              index: '/formalExaminationBZ',
              name: '形式审查材料补正',
              isShow: 1,
              allowViewing: 1

            },
                {
              index: '/techEvaluationBZ',
              name: '技术审查材料补正',
              isShow: 1,
              allowViewing: 1

            }

          ]
        },
             {
          index: '2',
          name: '地理标志申请',
          isShow: 1,
          allowViewing: 1,
          children: [
            {
              index: '/land',
              name: '填报申请',
              isShow: 1,
              allowViewing: 1

            },



            {
              index: '/drafts',
              name: '草稿箱',
              isShow: 1,
              allowViewing: 1

            },

            //
            // {
            //   index: '/drafts2',
            //   icon: 'el-icon-data-line',
            //   name: '填报申请2',
            //   isShow: 1,
            //   allowViewing: 1
            //
            // },

          ]
        },
        {
          index: '/applicationQuery',
          name: '申请信息查询',
          isShow: 1,
          allowViewing: 1
        },
        //   {
        //   index: '3',
        //   icon: 'el-icon-user',
        //   name: '个人中心',
        //   isShow: 1,
        //   allowViewing: 1
        // }
      ]
    }
  },

  computed: {
    ...mapState([
      'activeMenu1','titles'
    ]),
  },
  watch:{

    // 监听 Vuex 中的状态变化
   activeMenu1(newValue, oldVal) {
         this.activeMenu = newValue

    },
    titles(newValue, oldVal){
      this.$emit('custom-event', newValue)
      localStorage.setItem('titles', newValue)
    }
  },
  mounted () {
    this.activeMenu = localStorage.getItem('activeMenu') || '/binding'


  },
  methods: {
    // 选中菜单
    handleSelect (key, keyPath, item) { // evaluateList1
        this.$router.push(key)
        // 菜单项选中时的回调，可以用来更新activeMenu的值
        this.activeMenu = key
        // 将当前选中的菜单项保存到localStorage
        localStorage.setItem('activeMenu', key)


      let titles1 = item.parentMenu['$attrs'].name ? item.parentMenu['$attrs'].name + '-' : ''
      let titles2 = item['$attrs'].name ? item['$attrs'].name : ''
      let titles = titles1 + titles2
      localStorage.setItem('titles', titles)
      this.$emit('custom-event', titles)

    },

    // 递归遍历----是否显示菜单
    recursion (data, key, integer) {
      data.forEach(item => {
        if (item.children) {
          if (item.index == key) {
            item.isShow = integer
          }
          this.recursion(item.children, key, integer)
        } else {
          if (item.index == key) {
            item.isShow = integer
          }
        }
      })
    },

    handleOpen (key, keyPath) {
      localStorage.setItem('activeMenu', key)
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    }
  }
}
</script>

<style lang="less" scoped>
 .menuData_warp{
   width: 14rem;
   overflow-y: scroll;
   height: 100%;
   margin-right: 10px;
   background: rgb(27, 61, 109);
   scrollbar-width: none;
   box-sizing: border-box;
 }
</style>
<style>
.el-menu-item.is-active {
  background-color: rgb(63, 142, 255)!important;
}

.el-menu-item:hover {
  background-color: rgb(79, 107, 147) !important;
}
</style>



// WEBPACK FOOTER //
// src/landmark-user/components/menuData.vue